import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Hidden } from '@material-ui/core';
import { Button } from 'components/html-elements';
import { toast } from 'react-toastify';

import Icon from 'src/components/icon';
import LogoMonest from 'src/assets/images/logo-monest-purple.png';
import MobileMenu from 'src/components/mobile-menu';

import Avatar from 'components/avatar';

import { logout } from 'modules/auth/actions/authentication.action';

import {
    loadCompany,
    startDebts,
} from 'modules/company/actions/company.action';

import './admin-template.scss';

class AdminTemplate extends Component {

    componentDidMount() {
        const { company, authUser, loadCompany } = this.props;

        if (!company) {
            loadCompany(authUser.fk_company);
        }
    }

    render() {
        const {
            history: { location },
            children,
            authUser,
            loadingPendingDebts,
            pendingDebts,
            loadingStartDebts,
            startDebts,
            logout,
            company,
        } = this.props;

        return (
            <Grid container className="AdminTemplate">
                <Grid item xs={12} className="top">
                    <Grid item xs={12} md={9} className="left">
                        <Hidden smDown>
                            <Link to="/admin/dashboard" className="logo">
                                <img
                                    src={LogoMonest}
                                    alt="Monest"
                                    title="Monest"
                                />
                            </Link>
                            {
                                company && company.name && (
                                    <React.Fragment>
                                        <span className="separator" />
                                        <span className="company-name">
                                            {company.name || null}
                                        </span>
                                    </React.Fragment>
                                )
                            }
                        </Hidden>
                        <MobileMenu />
                    </Grid>
                    <Hidden smDown>
                        <Grid item xs={4} md={3} className="right">
                            <Grid
                                item
                                container
                                md={6}
                                push={{ md: 2 }}
                                className="auth-user"
                                alignItems="flex-end"
                            >
                                <span className="name">{authUser.name}</span>
                                <span className="role">
                                    {/* TODO: Alterar role do usuário ou remover se não houver */}
                                    Administrador
                                </span>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={3}
                                className="user-menu"
                            >
                                <Avatar username={authUser.name} />
                                <Button className="link" onClick={logout}>Sair</Button>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Grid>
                <Hidden smDown>
                    <Grid container className="top-menu">
                        <Grid item md={6} className="links-left">
                            <NavLink
                                activeClassName="active"
                                to="/admin/dashboard"
                            >
                                <Icon code="tachometer-alt" color="#B7C7D2" size={16} />
                                Dashboard
                            </NavLink>
                            <NavLink
                                activeClassName="active"
                                to="/admin/debtors"
                            >
                                <Icon code="user" color="#B7C7D2" size={16} />
                                Devedores
                            </NavLink>
                            <NavLink
                                activeClassName="active"
                                to="/admin/requests"
                            >
                                <Icon code="exclamation" color="#B7C7D2" size={16} />
                                Pendências
                            </NavLink>
                            {/* <NavLink
                                activeClassName="active"
                                to="/admin/financial"
                            >
                                <Icon code="dollar-sign" color="#B7C7D2" size={16} />
                                Financeiro
                            </NavLink>
                            <NavLink
                                activeClassName="active"
                                to="/admin/deals"
                            >
                                <Icon code="handshake" color="#B7C7D2" size={14} />
                                Acordos
                            </NavLink>
                            <NavLink
                                activeClassName="active"
                                to="/admin/surveys"
                            >
                                <Icon code="chart-line" color="#B7C7D2" size={14} />
                                Pesquisas
                            </NavLink> */}
                        </Grid>
                        <Grid item md={2} className="links-right">
                            <NavLink
                                activeClassName="active"
                                to="/admin/config"
                            >
                                <Icon code="cog" color="#B7C7D2" size={16} />
                                Configurações
                            </NavLink>
                        </Grid>
                    </Grid>
                </Hidden>

                {/* Dívidas pendentes */}
                {
                    (!loadingPendingDebts && pendingDebts && pendingDebts.total > 0 && location.pathname !== '/admin/dashboard') && (
                        <Grid container>
                            <Grid item xs={12}>
                                <div className="debts-banner">
                                    <Grid container justify="center">
                                        <Grid item xs={10} md={8} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <h1>{(pendingDebts.amount / 100).toLocaleString('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL',
                                            })} em dívidas pendentes
                                            </h1>
                                            <Button
                                                className="primary"
                                                loading={loadingStartDebts}
                                                onClick={({ ...props }) => {
                                                    startDebts(...props)
                                                        .then(() => toast.success('Cobrança iniciada! À partir de agora começaremos a entrar em contato com seus devedores.'));
                                                }}
                                            >
                                                Começar cobranças
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    )
                }

                <Grid container className="container">
                    {children}
                </Grid>
            </Grid>
        );
    }

}

const mapStateToProps = state => ({
    authUser: state.authentication.authUser,
    loadingPendingDebts: state.dashboard.loadingPendingDebts,
    pendingDebts: state.dashboard.pendingDebts,
    loadingStartDebts: state.company.loadingStartDebts,
    company: state.company.company,
});

const mapDispatchToProps = ({
    startDebts,
    logout,
    loadCompany,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdminTemplate);
